import { Control } from './control';
import { AccessibleMegaMenu } from './adobeAccessibleMenu';
import Headroom from "headroom.js";
import { gsap } from "gsap";

export class Megamenu extends Control {
    private navBar: HTMLElement;
    private navContent: HTMLElement;
    private navToggle: HTMLButtonElement;
    private navSearch: HTMLElement;
    private menuSlideAnimation: any;

    public static selector: string = ".megamenu";

    constructor(containerElement: Element) {
        super(containerElement);

        // Elements
        this.navBar = this.container as HTMLElement;
        this.navToggle = this.container.querySelector("#megamenuToggle") as HTMLButtonElement;
        this.navContent = this.container.querySelector(".nav__wrapper") as HTMLElement;
        this.navSearch = this.container.querySelector(".nav__search-panel") as HTMLElement;

        // Events 
        if (this.navToggle) {
            this.navToggle.addEventListener("click", event => this.onNavToggleClick(event));
        }

        
        // Initialize megamenu
        const menu = new AccessibleMegaMenu(this.navContent);

        const headroom = new Headroom(this.container, {
            "offset": 100,
            "tolerance": 5
        });
        headroom.init();

        // Mobile "hamburger" button toggle setup
        
        if (this.navToggle) {
            this.menuSlideAnimation = gsap.timeline({
                paused: true,
                onReverseComplete: function () {
                    const HTML = document.querySelector("html");
                    if (HTML) {
                        HTML.classList.remove("mobile-nav--open");
                    }
                }
            })
                .fromTo(this.navContent, 
                    { display: "none", autoAlpha: 0, xPercent: 100 }, 
                    { display: "flex", autoAlpha: 1, xPercent: 0, duration: .6, ease: "power4.out" }, "<");

            gsap.set(this.navContent, { clearProps: "all" });
        }

    }

    private showNav() {
        this.navToggle.setAttribute("aria-expanded", "true");
        this.navSearch.setAttribute("aria-hidden", "false");
        document.addEventListener("focusin", this.handleClosure);
        document.documentElement.classList.add("mobile-nav--open");
        this.menuSlideAnimation.timeScale(1).play();
        document.addEventListener("keyup", this.onEscapePress);
    }

    private hideNav() {
        this.navToggle.setAttribute("aria-expanded", "false");
        this.navSearch.setAttribute("aria-hidden", "true");
        document.removeEventListener("focusin", this.handleClosure);
        document.removeEventListener("keyup", this.onEscapePress);
        this.menuSlideAnimation.timeScale(1.5).reverse();
    }

    private onNavToggleClick(event: MouseEvent) {
        event.stopPropagation();
        const navDistance = this.navBar.getBoundingClientRect().top;
        if ((navDistance > 1) && (this.navToggle.getAttribute("aria-expanded") === "false")) {
            window.scrollBy(0, navDistance);
            setTimeout(this.showNav.bind(this), 10); //delay for iOS to allow scroll to begin
        } else if (this.navToggle.getAttribute("aria-expanded") === "false") {
            this.showNav();
        } else {
            this.hideNav();
        }
    }

    private handleClosure = (event: Event) => {
        // Narrow event.target to Node before passing to contains
        if (!(event.target instanceof Node) || !this.navContent.contains(event.target)) {
            this.hideNav();
        }
    };

    // If the user hits ESC, close menu
    private onEscapePress = (event: KeyboardEvent) => {
        if (event.key === "Escape" && this.navToggle.getAttribute("aria-expanded") === "true") {
            this.hideNav();
        }
    };

}
